import { Label } from "../label";

type Props = {
  name: string;
  label: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  register?: any;
  header?: boolean;
  setValue?: any;
  required?: boolean;
  onChange?: any;
  error?: any;
};

export default function SimpleTextAreaAutoHeight({
  name,
  label,
  value,
  defaultValue,
  placeholder,
  header = true,
  required,
  onChange,
}: Props) {
  return (
    <div>
      {header && <Label name={name} label={label} required={required} />}
      <div className="relative mt-2">
        <textarea
          className="block min-h-[42px] w-full resize-none rounded-md border border-gray-300 py-2 px-3 font-input text-input shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
          defaultValue={defaultValue}
          name={name}
          id={name}
          value={value}
          placeholder={placeholder}
          autoComplete="given-name"
          onChange={onChange}
        />
      </div>
    </div>
  );
}
